import {useCallback, useLayoutEffect, useRef, useState} from 'react';

/**
 * Encapsulates the map/list toggle state and scroll-position restoration
 * used on the Search page's responsive small-screen controller.
 *
 * When toggling from list → map the current scroll position is saved.
 * When toggling back from map → list the saved position is restored.
 */
export function useSearchMapToggle() {
  const [isMapActive, setIsMapActive] = useState(false);
  const listScrollYPosition = useRef(0);

  // Restore the correct view position before the browser paints. A normal
  // effect briefly renders the newly visible view at the browser's clamped
  // scroll position, which causes a noticeable bottom/top jump on mobile.
  useLayoutEffect(() => {
    window.scrollTo(0, isMapActive ? 0 : listScrollYPosition.current);
  }, [isMapActive]);

  const toggleController = useCallback(() => {
    setIsMapActive((active) => {
      if (!active) {
        listScrollYPosition.current = window.scrollY;
      }
      return !active;
    });
  }, []);

  return {isMapActive, toggleController} as const;
}
